/**
 * Device Detection Utility
 * Detects if user is on mobile device based on screen width and user agent
 */

export const isMobileDevice = () => {
  // Check screen width (mobile if less than 768px)
  const isMobileWidth = window.innerWidth < 768;
  
  // Check user agent for mobile devices
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  
  // Return true if either condition is met
  return isMobileWidth || isMobileUA;
};

export const getDeviceType = () => {
  return isMobileDevice() ? 'mobile' : 'desktop';
};
